var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    const showCards = (tax, grid) => {
        tax = '.' + tax;
        grid.querySelectorAll(tax).forEach((column) => {
            column.classList.add('active');
            let placeholder = column.querySelector('.placeholder');
            let photo = column.querySelector('.photo');
            if ( placeholder ) {
                let newImg = document.createElement("img");
                newImg.setAttribute('src', placeholder.getAttribute('data-src'));
                newImg.setAttribute('alt', placeholder.getAttribute('data-alt'));
                photo.removeChild(placeholder);
                photo.appendChild(newImg);

            }
        });

    }

    const initializeBlock = function ($block) {

        const teamBlocks = document.querySelectorAll('.block-team');
        if ( teamBlocks.length > 0 ) {
            for ( let teamblock of teamBlocks ) {
                const filterList = teamblock.querySelector('.block-team-filter__list');
                const filterLinks = filterList.querySelectorAll('a');
                const grid = teamblock.querySelector('.block-team-grid');
                for( let link of filterLinks ) {
                    link.addEventListener('click', (e) => {
                        let currentTax = e.target.getAttribute('data-tax');
                        if ( e.target.classList.contains('active') === false ) {
                            filterList.querySelector('.active').classList.remove('active');
                            e.target.classList.add('active');
                            grid.querySelectorAll('.active').forEach((el) => {
                                el.classList.remove('active');
                            });
                            showCards( currentTax, grid );
                        } 
                        e.preventDefault();
                    });
                }
            }
           

        }

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
     window.acf.addAction('render_block_preview/type=team', initializeBlock);
    }
});
